import React from 'react';
import Tooltip from "@material-ui/core/Tooltip";

// authorized_at llega en ISO UTC desde el backend; se muestra en la hora local del navegador
const formatAuthorizedAt = (iso) => {
    const date = new Date(iso);
    if (isNaN(date.getTime())) {
        return iso;
    }
    const day = date.toLocaleDateString('es-CO', { day: '2-digit', month: '2-digit', year: 'numeric' });
    const time = date.toLocaleTimeString('es-CO', { hour: '2-digit', minute: '2-digit' });
    return `${day} a las ${time}`;
}

// Nombres elegidos por cartera en cada check; si no hay, la cuenta que completo la autorizacion
const authorizedByNames = (order) => {
    const names = [order.quota_authorized_by, order.portfolio_authorized_by, order.documents_authorized_by]
        .filter((name) => name)
        .filter((name, index, all) => all.indexOf(name) === index);
    if (names.length > 0) {
        return names.join(', ');
    }
    return order.authorized_by_name || '';
}

export const authorizationTooltipText = (order) => {
    if (order.authorized_at) {
        const names = authorizedByNames(order);
        return `Autorizada por cartera el ${formatAuthorizedAt(order.authorized_at)}${names ? ' · ' + names : ''}`;
    }
    switch (order.status) {
        case 'COTIZACION':
            return 'Cotización: aún no se ha enviado a autorización';
        case 'SIN_AUTORIZAR':
            return 'Pendiente de autorización de cartera';
        case 'ANULADA':
            return 'Orden anulada sin registro de autorización';
        default:
            // ordenes anteriores a que se guardara la fecha de autorizacion
            return 'Sin registro de fecha de autorización';
    }
}

// formatter de react-bootstrap-table para la columna "#"
export const orderIdFormatter = (cell, row) => (
    <Tooltip title={authorizationTooltipText(row)} arrow placement="right">
        <span className='order-id-cell'>{cell}</span>
    </Tooltip>
);

export default {
    authorizationTooltipText,
    orderIdFormatter,
}
